import type { BasePlacement } from '@popperjs/core';
import classNames from 'classnames';
import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import type {
  PostLinkAccess,
  TopicMemberEditable,
  TopicPrivacy,
} from '../../graphql/generated/graphqlTypes';
import TopicPermissionInfo from './TopicPermissionInfo';
import styles from './TopicPermissionSelectOption.module.scss';

export type TopicPermissionOption<
  T extends TopicMemberEditable | TopicPrivacy | PostLinkAccess,
> = {
  value: T;
  label: string;
  icon: string;
  helpText: string;
  hidden?: boolean;
  tooltip?: string | null;
  tooltipPlacement?: BasePlacement;
  isDisabled?: boolean;
};

const TopicPermissionSelectOption = <
  T extends TopicMemberEditable | TopicPrivacy | PostLinkAccess,
  IsMulti extends boolean = false,
>(
  props: OptionProps<TopicPermissionOption<T>, IsMulti> & {
    isDisabled?: boolean;
  },
) => {
  return (
    <div className={classNames({ [styles.hide]: props.data.hidden })}>
      <components.Option {...props}>
        <TopicPermissionInfo {...props.data} />
      </components.Option>
    </div>
  );
};

export default TopicPermissionSelectOption;
